import { render } from "./LoadingBs5.vue?vue&type=template&id=6edee7e9&scoped=true"
import script from "./LoadingBs5.vue?vue&type=script&lang=js"
export * from "./LoadingBs5.vue?vue&type=script&lang=js"

import "./LoadingBs5.vue?vue&type=style&index=0&id=6edee7e9&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edee7e9"]])

export default __exports__